/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Icon from "../components/ui/Icon";
import { BOOKING_STATUS } from "../constants/constants";

const getStatusConfig = (status, isPaidOrder = false, type = "booking") => {
  const configs = {
    [BOOKING_STATUS.CONFIRMED]: {
      icon: <Icon.CheckCircle color="success" size={108} />,
      title: isPaidOrder ? "invoice_status_message_paid" : "status_confirmed",
    },
    [BOOKING_STATUS.CANCELLED]: {
      icon: <Icon.Cross color="danger" size={108} />,
      title: "status_cancelled",
    },
    [BOOKING_STATUS.PENDING]: {
      icon: <Icon.CheckCircle color="iconStroke" size={108} />,
      title: "status_pending",
      message: "booking_status_pending",
    },
    [BOOKING_STATUS.DELAY]: {
      icon: <Icon.PaymentProcessorDelay color="iconStroke" size={108} strokeWidth={0.5} />,
      title: "delay",
      message: "payment_status_message_delay",
    },
    [BOOKING_STATUS.ERROR]: {
      icon: <Icon.Error color="danger" size={108} />,
      title: "status_error",
      message: "payment_status_message_error",
    },
    [BOOKING_STATUS.PENDING_DELAY]: {
      icon: <Icon.PaymentProcessorDelay color="iconStroke" size={108} strokeWidth={0.5} />,
      title: "delay",
      message: "booking_status_pending",
    },
    [BOOKING_STATUS.RESCHEDULE_SUCCESS]: {
      icon: <Icon.CheckCircle color="success" size={108} />,
      title: "reschedule_success",
    },
    [BOOKING_STATUS.PENDING_PAYMENT]: {
      icon: <Icon.CheckCircle color="iconStroke" size={108} />,
      title: "status_pending",
      message: "payment_status_message_not_paid",
    },
  };

  const productOverrides = {
    [BOOKING_STATUS.PENDING]: {
      message: "",
    },
    [BOOKING_STATUS.DELAY]: {
      message: "product_payment_status_message_delay",
    },
    [BOOKING_STATUS.ERROR]: {
      message: "",
    },
    [BOOKING_STATUS.PENDING_DELAY]: {
      message: "",
    }
  };

  const config = configs[status];

  if (type === "product" && productOverrides[status]) {
    return { ...config, ...productOverrides[status] };
  }

  return config;
};

export default getStatusConfig;
